import { createAction } from '@reduxjs/toolkit';

export const setError = createAction<string>('error/setError');

export const clearError = createAction('error/clearError');
